import confetti from 'canvas-confetti';

export default function initConfetti() {

  const runConfetti = () => {

    // Set length of time for confetti to run.
    var end = Date.now() + (10 * 1000);

    // Set colors for confetti.
    var colors = ['#00A9E0', '#fdc55e'];

    (function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
  };

  // Check if the class is present on the body at page load.
  if (document.body.classList.contains('trigger-confetti')) {
    runConfetti();
  }

  // Add event listener to detect clicks on buttons or links with the "confetti" class.
  const confettiElements = document.querySelectorAll('button.confetti, a.confetti');
  confettiElements.forEach(element => {
    element.addEventListener('click', runConfetti);
  });
}